import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { tokenStore } from '../auth/tokenStore';

function ProtectedRoute({ children }) {
  const location = useLocation();
  if (!tokenStore.isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}

export default ProtectedRoute;
